import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import Features from "./Features";
import earnin from "../assets/earnin.png";
import destinedforx from "../assets/destinedforx.png";
import flatironschool from "../assets/flatironschool.jpeg";

function FeatureSection(props) {
  return (
    <Section
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="container">
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={1}
          spaced={true}
          className="has-text-centered"
        ></SectionHeader>
        <Features
          items={[
            {
              title: "Software Engineer @ User Interviews",
              dates: "Feb. 2021 - Present",
              description:
                "Currently working in a UX Engineer function on the Design System team building resuable & consistent components for the User Interviews web applications.",
              image: "https://www.userinterviews.com/images/ui-logo.jpg",
            },
            {
              title: "Software Engineer @ Earnin",
              dates: "Sept. 2019 - April 2020",
              description:
                "I worked as a Software Engineer on the web-frontend team at Earnin. We built internal tools for the Customer Experience team, building React applications in TypeScript supporting 1,000+ support agents.",
              image: earnin,
            },
            {
              title: "Programming Director @ Destined for X",
              dates: "Mar. 2017 - Present",
              description:
                "Improving educational outcomes for under-privileged and under-represented minorities from across California. Redesigned the company website in React and improved site performance using Google's Web Vitals assessment.",
              image: destinedforx,
            },
            {
              title: "Software Engineering Grad @ Flatiron School",
              dates: "Oct. 2018 - May 2019",
              description:
                "Graduated from an intensive 15-week Software Engineering Bootcamp in Seattle. Built full stack applications in Ruby, Ruby on Rails, JavaScript, React, Redux, and Node. Deployed to Heroku, AWS, and Netlify.",
              image: flatironschool,
            },
          ]}
        ></Features>
      </div>
    </Section>
  );
}

export default FeatureSection;
